import React, {useState} from 'react';
import css from './vpadd.module.css';
import DokumentasjonsCard from '../dokumentasjonsCards';

function VpDokumentasjonsDropdown({ title, products }){

    console.log(products);

    const [isOpen, setIsOpen] = useState(false);

    const sortedProducts = products.slice().sort((a, b) => {
        const supplierA = a.attributes.product.data.attributes.supplier.data.attributes.name.toLowerCase();
        const supplierB = b.attributes.product.data.attributes.supplier.data.attributes.name.toLowerCase();

        return supplierA.localeCompare(supplierB);
    });


    return(
        <div className={css.container}>
            <div className={css.ddTrigger} onClick={()=>{setIsOpen(!isOpen)}}>
                {title}
            </div>
            <div className={`${css.ddContent} ${isOpen ? css.active : ''}`}>
                <div className={css.cardDeck}>
                    {sortedProducts.map((product, index) => (
                    <DokumentasjonsCard 
                        key={index} 
                        product={product.attributes.product.data.attributes}
                        ordered_id={product.id}
                        // documentation={product.attributes.documentation.data}
                        serial={product.attributes.serial_number}
                    />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default VpDokumentasjonsDropdown;